export default __webpack_public_path__ + "static/media/526.395ef5fe.png";